import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from '../../Services/shared.service';
import { DialogeComponent } from '../dialoge/dialoge.component';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { JwtService } from '../../Services/jwt.service';
import { Constant } from '../../Constants/constant';
import { LookupLocationComponent } from '../lookup-location/lookup-location.component';
import { BaseComponent } from '../base/base.component';
import { MatPaginator } from '@angular/material/paginator';
import { ValidationService } from '../../Services/validation.service';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { Subject, firstValueFrom } from 'rxjs';
import { LoggingService } from '../../Services/NGLogger/logging-service.service';

@Component({
  selector: 'app-lookup-cost-center',
  templateUrl: './lookup-cost-center.component.html',
  styleUrls: ['./lookup-cost-center.component.css']
})
export class LookupCostCenterComponent extends BaseComponent {
  @ViewChild(MatPaginator, { static: false }) paginators!: MatPaginator;
  private locationInputSubject = new Subject<string>();
  private buInputSubject = new Subject<string>();
  CostlistData: any = [];
  SearchValue: string = "";
  isSearch: boolean = false;
  TabIndex: number = 0;
  Operation: string = "Add Cost Center";
  LocationListData: any = [];
  filteredLocations: any[] = [];
  filteredBu: any[] = [];
  BuListData: any = [];
  selectedOption: string = '';
  ValidBu: boolean = false;
  Validlocation: boolean = false;
  ManagerListData: any = [];
  filteredManagers: any[] = [];
  isNotSelect: boolean = false;
  renderer: any;
  IsBuLoading: boolean = false;
  IsLocationLoading: boolean = false;
  IsBuEnter: boolean = false;
  IsLocEnter: boolean = false;
  noDataBu: boolean = false;
  noDataLocations: boolean = false;
  override showloader: boolean = true;
  formGroup!: FormGroup;
  Submitted: any;
  constructor(
    public dialogRef: MatDialogRef<LookupCostCenterComponent>,
    private sharedService: SharedService,
    private Diloge: MatDialog,
    private validationService: ValidationService,
    private loggingService: LoggingService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private jwtService: JwtService) { super(); if (this.dialogData.IsClientDetail) this.isNotSelect = true; }
  override ngOnInit(): void {
    this.formInit();
    this.LoadCostCenterListData();
    this.setupLocationSubscription(); this.setupBusinessUnitSubscription();this.LoadManagerListData();
  }

  formInit() {
    this.formGroup = this.fb.group({
      Id: [0],
      Name: ["", [Validators.required]],
      Description: ["", [Validators.required]],
      LocationId: [null],
      EpId: [this.jwtService.getEnterPriseId()],
      CreatedOn: [""],
      CreatedBy: [""],
      IsActive: [true],
      BUId: [null],
      ManagerId: [null, [Validators.required]],
      selectedOption: ["", Validators.required]
    });
  }

  onPopupClose() {
    this.dialogRef.close('popClose');
  }
  changeTab(event: any) {
    if (event.index === 0) {
      this.formGroup.patchValue({
        Name: "",
        Description: "",
        LocationId: null,
        Location: "",
        BUId: null,
        BU: "",
        selectedOption: ["", Validators.required]
      });

      this.ValidBu = false;
      this.Validlocation = false;
      this.selectedOption = "";
      this.noDataLocations = false;
      this.Operation = "Add Cost Center";
      this.Submitted = false;
    }
    this.TabIndex = event.index;
  }

  gotoBack() {
    this.Operation = "Add Cost Center";
    this.TabIndex = 0;
  }
  clearSearchField() {
    this.SearchValue = "";
    this.LoadCostCenterListData();
  }
  SelectCost(data: any) {
    if (!this.isNotSelect)
      this.dialogRef.close(data);
  }
  clickMethod(item: any) {
    let jobid = item.jobId;
    const dialogRef = this.Diloge.open(DialogeComponent, {
      width: '30%',
      maxHeight: '90%',
      panelClass: 'modal-matdelete',
      data: { "title": "Warning!", "prefix":"Are you sure you want to delete ","message":  item.name + "?" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data.event == 'Yes') {
        this.DeleteCostCenter(item)
      }
    })
  }
  async Edit(data: any) {
    try {
      const res: any = await firstValueFrom(this.sharedService.GetCostCenterByID(data.id));

      if (res) {
        this.formGroup.patchValue({
          Id: data.id,
          Name: res?.data?.name,
          Description: res?.data?.description,
          CreatedBy: res?.data.createdBy,
          CreatedOn: res?.data.createdOn,
          IsActive: res?.data.isActive,
          EpId: this.dialogData.EpId ?? 0
        });

        this.filteredManagers = [];
        this.filteredLocations = [];
        this.filteredBu = [];

        const location = data.location ? data.location.trim() : '';
        const locationInfo = data.locationInfo ? data.locationInfo.trim() : '';
        const combinedLocation = location ? `${location}${locationInfo ? ',' + locationInfo : ''}` : locationInfo;

        if (parseInt(res?.data.managerId ?? 0) > 0) {
          this.filteredManagers.push({ id: data.managerId, fullName: data.managerName });
        }

        if (parseInt(res?.data.locationId ?? 0) > 0) {
          this.filteredLocations.push({ id: res.data?.locationId, locationName: data.location, locationInfo: combinedLocation });
        }
        this.setFormControlValueNew('LocationId', res.data?.locationId, this.filteredLocations);

        if (parseInt(res?.data.buId ?? 0) > 0) {
          this.filteredBu.push({ id: res.data?.buId, name: `${data.bussinessUnitName} : ${data.locationInfo}` });
        }
        this.setFormControlValueNew('BUId', res.data?.buId, this.filteredBu);

        this.setFormControlValueNew('ManagerId', res.managerId, this.filteredManagers);

        if (this.formGroup.value.BUId) {
          this.formGroup.patchValue({ selectedOption: "businessUnit" });
          this.selectedOption = "businessUnit";
          this.IsBuLoading = false;
        } else if (this.formGroup.value.LocationId) {
          this.formGroup.patchValue({ selectedOption: "location" });
          this.selectedOption = "location";
          this.IsLocationLoading = false;
        }

        this.Operation = "Update Cost Center";
        this.TabIndex = 1;
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }


  async DeleteCostCenter(data: any) {
    try {
      const res: any = await firstValueFrom(this.sharedService.DeleteCostCenter(data.id));

      if (res) {
        if (res.succeeded) {
          this.showToastr(res?.messages[0]);
          this.LoadCostCenterListData();
        } else {
          this.showToastr(res?.messages[0], 'error');
        }
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }
  async onSubmit() {
    this.Submitted = true;
    this.formGroup.patchValue({ EpId: this.dialogData.EpId ?? 0 });
    const savValue = JSON.parse(JSON.stringify(this.formGroup.value));
    this.copyFormValues(this.formGroup, this.formGroup, [
      { sourceControlName: 'ManagerId', targetControlName: 'ManagerId', nestedKey: 'id' },
      { sourceControlName: 'LocationId', targetControlName: 'LocationId', nestedKey: 'id' },
      { sourceControlName: 'BUId', targetControlName: 'BUId', nestedKey: 'id' }
    ]);
    if (this.formGroup.valid) {
      const locationValid = (this.formGroup.value.LocationId ?? 0 > 0);
      const businessUnitValid = (this.formGroup.value.BUId ?? 0 > 0);
      if (!locationValid && !businessUnitValid) {
        this.showToastr("Please fill either Location or Business Unit", 'error');
        return;
      }
      try {
        const res: any = await firstValueFrom(this.sharedService.addUpdateCostCenter(this.formGroup.value));
        if (res.succeeded) {
          this.showToastr(res.messages[0]);
          this.LoadCostCenterListData();
          const userType = this.getUserView(this.jwtService.getUserType());
          const isAdminViewingClient = this.Utype.Admin === this.jwtService.getUserType() && this.Utype.Client === userType;
          if (isAdminViewingClient) {
            this.handleAdminViewingClient();
          } else {
            this.handleUserViewing();
          }
          this.TabIndex = 0;
          this.Submitted = false;
        } else {
          this.formGroup.patchValue(savValue);
          const concatenatedMessage = res?.messages?.map((msg: any) => msg).join('\n');
          this.showToastr(concatenatedMessage, 'error');
        }
      } catch (err) {
        this.loggingService.captureException(err);
      }
    }
    else{
      this.formGroup.patchValue(savValue);
    }
  }

  paginationchanged(e: any) {
    this.LoadCostCenterListData();
  }

  async LoadCostCenterListData() {
    this.Paginator.Length = 0;
    const searchData = this.SearchValue === "" ? "All" : this.SearchValue;
    const searchVm = {
      search: searchData,
      PageNumber: this.Paginator.PageIndex + 1,
      PageSize: this.Paginator.PageSize,
      EpId: this.dialogData.EpId || 0
    };
    try {
      const res: any = await firstValueFrom(this.sharedService.getCostCenterList(searchVm));
      if (res) {
        this.CostlistData = res.data.items;
        this.Paginator.Length = this.CostlistData.length > 0 ? res?.data?.totalRecords : 0;
        if (this.isSearch) {
          if (this.paginators) {
            this.paginators.pageIndex = 0;
          }
        }
        this.isSearch = false;
        this.showloader = false;
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

  async LoadLocationListData(): Promise<void> {
    const searchData = this.SearchValue === "" ? " " : this.SearchValue;
    const searchVm = {
      Search: searchData,
      PageSize: 0,
      PageNumber: 0,
      EpId: this.dialogData?.EpId
    };

    try {
      const res: any = await firstValueFrom(this.sharedService.getEPLocationList(searchVm));
      if (res && res.data && res.data.items) {
        this.LocationListData = res.data.items;
        this.filteredLocations = this.LocationListData.map((item: any) => ({
          id: item.id,
          locationName: item.locationName,
          locationInfo: this.formatLocationInfo(item)
        }));
      } else {
        throw new Error("Error fetching location list: Response structure invalid");
      }
    } catch (error) {
      this.loggingService.captureException(error);
    }
  }

  async LoadBUListData(): Promise<void> {
    const searchData = this.SearchValue;
    const searchVm = {
      search: searchData,
      PageNumber: 0,
      PageSize: 0,
      EpId: this.dialogData.EpId
    };

    try {
      const res: any = await firstValueFrom(this.sharedService.getBusinessUnitList(searchVm));
      if (res) {
        this.BuListData = res?.data?.items;
        this.filteredBu = res?.data?.items
          .filter((item: any) => item.name && item.name.trim() !== '')
          .map((item: any) => ({ id: item.id, name: item.name }));
      }
    } catch (error) {
      this.loggingService.captureException(error);
    }
  }

  formatDate(date: any) {
    let newDate = Constant.formatDate(date);
    return this.sharedService.formatDate(newDate);
  }

  async setupLocationSubscription(): Promise<void> {
    try {
      this.locationInputSubject.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap(async (userInput: string) => {
          const searchVm = {
            Search: userInput,
            PageSize: 0,
            PageNumber: 0,
            EpId: this.dialogData?.EpId
          };

          try {
            const res: any = await firstValueFrom(this.sharedService.getEPLocationList(searchVm));

            if (res) {
              this.LocationListData = res?.data?.items;
              this.filteredLocations = res?.data?.items.map((item: any) => ({
                id: item.id,
                locationName: item.locationName,
                locationInfo: this.formatLocationInfo(item)
              }));
              this.noDataLocations = this.filteredLocations.length === 0 && userInput.trim().length > 0;
              if (this.noDataLocations) {
                this.formGroup.patchValue({ LocationId: null, Location: "" });
              }
              this.IsLocationLoading = false;
            }
          } catch (err) {
            this.filteredLocations = [];
            this.noDataLocations = true;
            this.IsLocationLoading = false;
            this.loggingService.captureException(err);
          }
        })
      ).subscribe();
    } catch (ex) {
      this.loggingService.captureException(ex);
    }
  }

  filterLocations(e: any) {
    this.IsLocEnter = true;
    this.IsLocationLoading = true;
    const userInput = e.target.value.toLowerCase();
    this.locationInputSubject.next(userInput);
    if (e.target.value === '') {
      this.formGroup.patchValue({ LocationId: null });
    }
  }

  onOptionSelectedL(event: any) {
    const selectedOption = this.filteredLocations.find(option => option.id === event.option.id);
    if (selectedOption) {
      this.formGroup.patchValue({ LocationId: selectedOption.id });
      this.Validlocation = false;
    }
  }

  async location_popup(): Promise<void> {
    this.IsLocationLoading = true;
    const dialogRef = this.Diloge.open(LookupLocationComponent, {
      width: '90%',
      maxHeight: '90%',
      minHeight: '410px',
      panelClass: 'modal-matdelete',
      data: { EpId: this.dialogData.EpId },
      disableClose: true
    });

    try {
      const data = await firstValueFrom(dialogRef.afterClosed());
      if (data) {
        await this.LoadLocationListData();
        const selectedOption = this.filteredLocations.find(option => option.locationName === data.locationName);
        if (selectedOption) {
          this.formGroup.patchValue({ LocationId: selectedOption });
        }
        this.IsLocationLoading = false;
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

  setFormControlValueNew(controlName: string, id: string | undefined, categoryList: any[]) {
    const item = categoryList.find((x: any) => x.id === Number(id));
    if (item) {
      this.formGroup.controls[controlName].setValue(item);
    }
  }

  OnBlankInput(e: any) {
    if (e.target.value == '' || e.target.value == null) {
      this.LoadCostCenterListData();
    }
  }

  async setupBusinessUnitSubscription(): Promise<void> {
    try {
      this.IsBuLoading = true;
      this.buInputSubject.pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(async (userInput) => {
        const searchVm = {
          search: userInput ?? "",
          PageNumber: this.Paginator.PageIndex + 1,
          PageSize: this.Paginator.PageSize,
          EpId: this.dialogData.EpId
        };
        try {
          const res = await firstValueFrom(this.sharedService.getBusinessUnitList(searchVm));
          if (res) {
            this.BuListData = res?.data?.items;
            this.filteredBu = res?.data?.items
              .filter((item: any) => item.name && item.name.trim() !== '')
              .map((item: any) => ({ id: item.id, name: item.name + " : " + item.locationInfo }));
            this.IsBuLoading = false;
            this.noDataBu = this.filteredBu.length === 0 && userInput.trim().length > 0;
          } else {
            this.filteredBu = [];
            this.noDataBu = true;
            this.IsBuLoading = false;
          }

        } catch (err) {
          this.loggingService.captureException(err);
          this.IsBuLoading = false;
        }
      });
    } catch (ex) {
      this.loggingService.captureException(ex);
      this.IsBuLoading = false;
    }
  }

  filterBu(e: any) {
    this.IsBuLoading = true;
    this.IsBuEnter = true;
    const userInput = e.target.value.toLowerCase();
    this.buInputSubject.next(userInput);
    if (e.target.value === '') {
      this.formGroup.patchValue({ BUId: null});
    }
    this.IsBuLoading = false;
  }

  onOptionSelectedBU(event: any) {
    const selectedOption = this.filteredBu.find(option => option.id === event.option.id);
    if (selectedOption) {
      this.formGroup.patchValue({ BUId: selectedOption.id });
      this.ValidBu = false;
    }
  }

  resetIds() {
    if (this.formGroup.controls['selectedOption'].value == 'businessUnit') {
      this.selectedOption = "businessUnit";
      this.formGroup.patchValue({ LocationId: null});
      this.ValidBu = true;
      this.IsBuLoading = false;
      this.noDataBu = false;
    }
    else {
      this.formGroup.patchValue({ BUId: null });
      this.formGroup.patchValue({ LocationId: null});
      this.formGroup.controls['LocationId'].setValidators([Validators.required]);
      this.formGroup.controls['LocationId'].updateValueAndValidity();
      this.formGroup.controls['BUId'].clearValidators();
      this.formGroup.controls['BUId'].updateValueAndValidity();
      this.selectedOption = "location";
      this.Validlocation = true;
      this.noDataLocations = false;
      this.IsLocationLoading = false;
    }
  }

  ngAfterViewInit(): void {
    const matOptions = document.querySelectorAll('.mat-option');
    matOptions.forEach((option: Element, index: number, options: NodeListOf<Element>) => {
      if (index < options.length - 1) {
        this.renderer.setStyle(option, 'border-bottom', '1px solid #ccc');
      }
    });
  }

  async LoadManagerListData(): Promise<void> {
    try {
      const searchData = this.SearchValue.trim() ? this.SearchValue : " ";
      const res = await firstValueFrom(this.sharedService.getManagerList(searchData, this.dialogData.EpId, null, null));
      if (res) {
        const managerList = res?.data.filter((item: any) => item.fullName && item.fullName.trim() !== '');
        this.ManagerListData = managerList;
        this.filteredManagers = managerList.map((item: any) => ({ id: item.id, fullName: item.fullName }));
      }
      const userType = this.getUserView(this.jwtService.getUserType());
      const isAdminViewingClient = this.Utype.Admin === this.jwtService.getUserType() && this.Utype.Client === userType;
      if (isAdminViewingClient) {
        this.handleAdminViewingClient();
      } else {
        this.handleUserViewing();
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

  handleAdminViewingClient() {
    const selectedClientUserId = localStorage.getItem('selectedClientUserId') ?? '';
    const selectedOption = this.filteredManagers.find(option => option.id === Number(selectedClientUserId));
    if (selectedOption) {
      this.formGroup.patchValue({ ManagerId: selectedOption });
    }
  }

  handleUserViewing() {
    const loginUserId = this.jwtService.getUserId();
    let selectedOption = this.filteredManagers.find(option => option.id === loginUserId);
    if (!selectedOption) {
      selectedOption = this.ManagerListData.find((option: any) => option.email === this.dialogData.Email);
    }
    if (selectedOption) {
      this.formGroup.patchValue({ LocationId: selectedOption });
      this.formGroup.patchValue({
        ManagerId: selectedOption
      });
    }
  }

  onOptionSelectedManager(event: any) {
    const selectedOption = this.filteredManagers.find(option => option.id === event.option.id);
    if (selectedOption) {
      this.formGroup.patchValue({ ManagerId: selectedOption });
    }
  }

  async filterManager(e: any): Promise<void> {
    try {
      const userInput = e.target.value.toLowerCase();
      const res = await firstValueFrom(this.sharedService.getManagerList(userInput, this.dialogData.EpId, null, null));
      if (res) {
        this.ManagerListData = res?.data.filter((item: any) => item.fullName && item.fullName.trim() !== '');
        this.filteredManagers = this.ManagerListData.map((item: any) => ({ id: item.id, fullName: item.fullName }));
      }
      if (e.target.value === '') {
        this.formGroup.patchValue({ ManagerId: 0 });
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

  setPagination(e: any) {
    this.Paginator.PageSize = e.pageSize;
    this.Paginator.PageIndex = e.pageIndex;
    this.LoadCostCenterListData();
  }

  onSearch() {
    this.isSearch = true;
    this.showloader = true;
    this.Paginator.PageIndex = 0;
    this.LoadCostCenterListData();
  }
  omitSpecialChar(event: KeyboardEvent): void {
    const isValid = this.validationService.omitValidateSpecialChar(event);
    if (!isValid) {
      event.preventDefault();
    }
  }
  removeSpaces(e: any) {
    this.validationService.removeSpaces(e);
  }

  omitValidateSpecialChar(event: any) {
    const isValid = this.validationService.omitValidateSpecialChar(event);
    if (!isValid) {
      event.preventDefault();
    }
  }
  omitSpecialCharNumber(event: any) {
    this.validationService.omitSpecialCharNumber(event);
  }

  allowAlphaNumericHyphen(event: any) {
    this.validationService.allowAlphaNumericHyphen(event);
  }

  onInputChange(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.value === '') {
      this.onSearch();
    }
  }

  handlePaste(event: ClipboardEvent,type: any): void {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const sanitizedText = this.validationService.allowAlphaNumericHyphen(pastedText) as string;
    const target = event.target as HTMLInputElement;
    const start = target.selectionStart || 0;
    const end = target.selectionEnd || 0;
    target.value = target.value.slice(0, start) + sanitizedText + target.value.slice(end);
    target.setSelectionRange(start + sanitizedText.length, start + sanitizedText.length);
    if(type = 1){
    this.formGroup.patchValue({ Name: target.value });
    }
  }
}
